import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import './styles.css';
import './i18n';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { AntdLocaleProvider } from './components/AntdLocaleProvider';
import { RootErrorBoundary } from './components/RootErrorBoundary';
import { Bootstrap } from './auth/Bootstrap';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <RootErrorBoundary>
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <AntdLocaleProvider>
          <Bootstrap />
        </AntdLocaleProvider>
      </I18nextProvider>
    </React.StrictMode>
  </RootErrorBoundary>
);
